import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    icon: {
      width: 20,
      height: 20,
      marginRight: 9,
      '&:last-child': {
        marginRight: 0,
      },
      [theme.breakpoints.up('md')]: {
        width: 24,
        height: 24,
      },
    },
    filledIcon: {
      '& polygon': {
        fill: 'currentColor',
      },
    },
  });
});

export default useStyles;
